import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-zinc-900/30 border-y border-zinc-800/50" data-id="element-131">
      <div className="max-w-3xl mx-auto space-y-16" data-id="element-132">
        {/* The Problem */}
        <div className="space-y-6" data-id="element-133">
          <FadeIn data-id="element-134">
            <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8" data-id="element-135">
              Vives en un estado de parálisis por análisis.
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-136">
            <p className="text-lg text-zinc-300 leading-relaxed" data-id="element-137">
              Tu autoestima se ha convertido en un castillo de naipes que se cae
              con cualquier crítica externa o pensamiento de inseguridad.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-138">
            <p className="text-lg text-zinc-300 leading-relaxed" data-id="element-139">
              Sientes cansancio crónico emocional, una presión constante en el
              estómago al tomar decisiones y la sensación de que tu vida está en
              pausa mientras el resto del mundo avanza. Has intentado pensar en
              positivo, pero tu cuerpo sigue sintiéndose pesado, rígido y lleno
              de miedo.
            </p>
          </FadeIn>
        </div>

        {/* Why it didn't work */}
        <div className="pt-8" data-id="element-140">
          <FadeIn data-id="element-141">
            <h3 className="text-2xl font-bold mb-8 text-center text-zinc-100" data-id="element-142">
              Por qué lo que has intentado no funcionó
            </h3>
          </FadeIn>

          <div className="space-y-6" data-id="element-143">
            {['Las afirmaciones positivas fallan porque intentas convencer a una mente que está en modo "supervivencia".', 'Los libros de teoría espiritual no resuelven bloqueos que están almacenados físicamente en tus caderas, garganta y plexo solar.', 'Meditar de forma pasiva a veces solo te da más espacio para sobrepensar si no descargas primero la tensión acumulada.'].map((text, i) => <FadeIn key={i} delay={0.1 * (i + 1)} direction="up" data-id="element-144">
                <div className="flex items-start gap-4 glass-panel p-6 rounded-2xl" data-id="element-145">
                  <XCircle className="w-6 h-6 text-zinc-500 shrink-0 mt-0.5" data-id="element-146" />
                  <p className="text-zinc-300" data-id="element-147">{text}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}